import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import AodIcon from '@mui/icons-material/Aod';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, setDoc, doc, Timestamp } from 'firebase/firestore';
import {
  getDatabase,
  ref as dbref,
  runTransaction,
  set,
  child,
  get,
  update,
  serverTimestamp,
  push,
} from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { MuiFileInput } from 'mui-file-input';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

dayjs.extend(utc);
dayjs.extend(timezone);

// TODO: Replace the following with your app's Firebase project configuration
// See: https://support.google.com/firebase/answer/7015592
const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
const rtdb = getDatabase(app);

// TODO remove, this demo shouldn't need to reset the theme.
export default function NewProductPage() {
  const [loading, setLoading] = React.useState(false);
  const [fileInputError, setFileInputError] = React.useState(false);
  const [thumbnailInputError, setThumbnailInputError] = React.useState(false);
  const [prefixError, setPrefixError] = React.useState(false);
  const [titleError, setTitleError] = React.useState(false);
  const [subtitleError, setSubTitleError] = React.useState(false);
  const [venueError, setVenueError] = React.useState(false);
  const [descriptionError, setDescriptionError] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [thumbnail, setThumbnail] = React.useState(null);
  const [startdate, setstartDate] = React.useState(dayjs.utc());
  const [enddate, setendDate] = React.useState(dayjs.utc());

  const [starttime, setstartTime] = React.useState(dayjs.utc('2022-04-17T12:00'));
  const [endtime, setendTime] = React.useState(dayjs.utc('2022-04-17T13:00'));
  const [prefix, setPrefix] = React.useState('');

  const navigate = useNavigate();

  const handleOnChangeUploadfile = (newFile) => {
    setFile(newFile);
  };

  const handleOnChangeUploadThumbnail = (newFile) => {
    setThumbnail(newFile);
  };

  const handleOnChangePrefix = (event) => {
    setPrefix(event.target.value.trim().toLowerCase());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    const data = new FormData(event.currentTarget);

    const auth = getAuth();
    const user = auth.currentUser;

    let titlePass = false;
    let descriptionpass = false;
    let prefixPass = false;

    if (data.get('title').length > 2) {
      titlePass = true;
      setTitleError(false);
    } else {
      setTitleError(true);
    }

    if (data.get('prefix').length > 2) {
      prefixPass = true;
      setPrefixError(false);
    } else {
      setPrefixError(true);
    }

    if (data.get('description').length > 2) {
      descriptionpass = true;
      setDescriptionError(false);
    } else {
      setDescriptionError(true);
    }

    if (titlePass && descriptionpass && prefixPass) {
      update(dbref(rtdb, `services/${data.get('prefix')}`), {
        prefix: data.get('prefix'),
        title: data.get('title'),
        subtitle: data.get('subtitle') || null,
        description: data.get('description'),
        created: Timestamp.fromDate(new Date()).toMillis(),
        createdby: user.uid,
        date: startdate.format() || null,
      }).then(() => {
        setLoading(false);
        navigate('/dashboard/services');
      });
    } else {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Grid
        style={{
          width: '100%',
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Grid
          style={{
            width: '100%',
            marginTop: 60,
            maxWidth: 1200,
            display: 'flex',
            padding: 25,
            height: '80vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <CircularProgress color="inherit" />
          </Box>
        </Grid>
      </Grid>
    );
  }

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <AodIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          New Services
        </Typography>
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3}>
              <TextField
                autoComplete="off"
                name="prefix"
                required
                fullWidth
                id="prefix"
                label="Prefix"
                autoFocus
                error={prefixError}
                value={prefix.trim()}
                onChange={handleOnChangePrefix}
                inputProps={{ style: { textTransform: 'lowercase' } }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                required
                id="title"
                error={titleError}
                label="Title"
                name="title"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                required
                id="subtitle"
                error={subtitleError}
                label="Sub Title"
                name="subtitle"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                required
                error={descriptionError}
                id="description"
                label="Description"
                name="description"
                autoComplete="off"
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
            Add Services
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
